import Resource from './Resource';
class BillingChangelog extends Resource {
	constructor() {
		super('billingchangelogs');
	}
}
export default new BillingChangelog();
